import { characters } from '@/mocks/characters';

export default function CharacterShowcase() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <p className="text-primary-600 text-sm font-medium tracking-wider mb-2">
            —— 角色介绍 ——
          </p>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900">
            主要角色
          </h2>
          <p className="text-foreground-500 text-sm md:text-base mt-3 max-w-[550px] mx-auto">
            每一个角色都承载着独特的命运与故事，他们是亚当君挣扎旅程中不可或缺的存在
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {characters.map((char) => (
            <div
              key={char.id}
              className="group relative bg-background-100 rounded-lg overflow-hidden transition-all duration-500 hover:-translate-y-1"
            >
              <div className="relative w-full h-[320px] overflow-hidden">
                <img
                  src={char.image}
                  alt={char.name}
                  className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-950/80 via-transparent to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-5">
                  <span className="inline-block px-3 py-1 rounded-full bg-accent-500/20 text-accent-300 text-xs font-medium mb-2">
                    {char.title}
                  </span>
                  <h3 className="font-heading text-xl text-background-50 font-bold">
                    {char.name}
                  </h3>
                </div>
              </div>
              <div className="p-5">
                <p className="text-foreground-600 text-sm leading-relaxed mb-4">
                  {char.description}
                </p>
                <div className="flex flex-wrap gap-2">
                  {char.traits.map((trait) => (
                    <span
                      key={trait}
                      className="px-2.5 py-1 rounded-full bg-background-200 text-foreground-600 text-xs"
                    >
                      {trait}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}